import { useCallback } from 'react';
import { TextField, Tooltip} from '@mui/material';

import { useStepValidator } from 'Hooks/useStepValidator';
import { INPUT_STEP_NAMES } from 'Pages/Inputs/constants';
import { useInputStore } from 'Store';

export const SimulationEndDate = () => {
  const sim_end_date = useInputStore(state => state.sim_end_date)
  const sim_start_date = useInputStore(state => state.sim_start_date)
  const setValue = useInputStore((state) => state.set_value)

  const handleChange = (event) => {
    setValue({ 'sim_end_date': event.target.value})
  }

  // validation
  const isValidDate = useCallback(() => {
    const date = new Date(sim_end_date)
    const start_date = new Date(sim_start_date)

    // is it a valid date && after start date
    return !isNaN(date) && date > start_date
  }, [sim_end_date, sim_start_date])

  useStepValidator(INPUT_STEP_NAMES.simulation, 'sim_end_date', () => isValidDate(sim_end_date, sim_start_date))
  
  return (
    <Tooltip title='What date do you want to end the simulation?'>
      <TextField
        size='small'
        label='End Simulation'
        type='date'
        InputLabelProps={{
          shrink: true,
        }}
        value={sim_end_date}
        onChange={handleChange}
        error={!isValidDate()}
        helperText={!isValidDate() ? 'Please select a valid date after Simulation Start Date' : ''}
      />
    </Tooltip>
  )
}
